import {InputText, Select} from '@/components/Form/index.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemBms} from '../BM/FormChooseBm.jsx'
import {FormItemFms} from '../FM/FormChooseFm.jsx'
import {FormItemSs} from '../SS/FormChooseSs.jsx'
import BdType from './BdType.mjs'
import Model from './ModelBd.mjs'

export const FormItemBdName = (props) => (
    <FormItemBizProp
        Model={Model}
        prop="bdName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemBdNo = (props) => (
    <FormItemBizProp
        Model={Model}
        prop="bdNo"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemBdType = (props) => (
    <FormItemBizProp
        Model={Model}
        prop="bdType"
        {...props}
    >
        <Select
            allowClear
            getOptionKey={e => e[0]}
            getOptionLabel={e => e[1]}
            options={BdType}
        />
    </FormItemBizProp>
)

export default function FormChooseBd(props) {
    const map = useMapContext()
    const {subTypeCode} = map.data

    return (
        <FormChooseDesign {...props}>
            {'BODA1' === subTypeCode ? <FormItemBms /> : <FormItemFms />}
            <FormItemSs />
            <FormItemBdNo />
            <FormItemBdName />
            <FormItemBdType />
        </FormChooseDesign>
    )
}
